import { Global } from '@emotion/react';
import React from 'react';

const Fonts = () => (
  <Global
    styles={`
            @font-face {
                font-family: 'Mueller';
                src: url('/fonts/MullerRegular.ttf') format('truetype');
                font-weight: normal;
                font-style: normal;
            }
            @font-face {
                font-family: 'Mueller';
                src: url('/fonts/MullerRegularItalic.ttf') format('truetype');
                font-weight: normal;
                font-style: italic;
            }
            @font-face {
                font-family: 'Mueller';
                src: url('/fonts/MullerBold.ttf') format('truetype');
                font-weight: bold;
                font-style: normal;
            }
            @font-face {
                font-family: 'Mueller';
                src: url('/fonts/MullerBoldItalic.ttf') format('truetype');
                font-weight: bold;
                font-style: italic;
            }
            @font-face {
                font-family: 'Mueller';
                src: url('/fonts/MullerLight.ttf') format('truetype');
                font-weight: 100;
                font-style: normal;
            }
            @font-face {
                font-family: 'Mueller';
                src: url('/fonts/MullerLightItalic.ttf') format('truetype');
                font-weight: 100;
                font-style: italic;
            }  
            @font-face {
                font-family: 'Mueller';
                src: url('/fonts/MullerMedium.ttf') format('truetype');
                font-weight: medium;
                font-style: normal;
            }
            @font-face {
                font-family: 'Mueller';
                src: url('/fonts/MullerMediumItalic.ttf') format('truetype');
                font-weight: medium;
                font-style: italic;
            }                                                                                                                                                                      
        `}
  />
);

export default Fonts;
